import { render, staticRenderFns } from "./ReportsWarning.vue?vue&type=template&id=722bd125&"
import script from "./ReportsWarning.vue?vue&type=script&lang=js&"
export * from "./ReportsWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports